function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.2,
  d: "M10 11H30L22 20.46V27L18 29V20.46L10 11Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.8667 10.8273C30.6316 10.3228 30.1238 10 29.5652 10H10.4348C9.8762 10 9.36839 10.3228 9.13329 10.8273C8.89818 11.3318 8.97854 11.9264 9.33924 12.351L16.6522 20.9612V28.5714C16.6522 29.0665 16.9097 29.5263 17.3327 29.7866C17.7556 30.0469 18.2838 30.0706 18.7286 29.8492L22.5547 27.9444C23.0408 27.7024 23.3478 27.2078 23.3478 26.6667V20.9612L30.6608 12.351C31.0215 11.9264 31.1018 11.3318 30.8667 10.8273ZM26.4728 12.8571L20.8175 19.5156C20.5984 19.7735 20.4783 20.1003 20.4783 20.4381V25.7838L19.5217 26.26V20.4381C19.5217 20.1003 19.4016 19.7735 19.1825 19.5156L13.5272 12.8571H26.4728Z",
  fill: "#6F62FF"
});

var SvgAudienceFilter = function SvgAudienceFilter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAudienceFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audience_filter.3df74abe.svg";
export { ForwardRef as ReactComponent };